import { z } from "zod";
export const OPENAI_VIDEO_MODELS = ["sora-2", "sora-2-pro"];
export const OPENAI_VIDEO_MODEL_PROFILES = {
    "sora-2": {
        id: "sora-2",
        label: "Sora 2",
        tier: "rapid",
        badge: "FAST ITERATION",
        description: "A responsive creative model for exploring scenes, motion, and visual direction.",
        outputDescription: "720p generation · platform-ready upscale",
        supports1080p: false,
    },
    "sora-2-pro": {
        id: "sora-2-pro",
        label: "Sora 2 Pro",
        tier: "production",
        badge: "PRODUCTION QUALITY",
        description: "OpenAI's highest-fidelity Sora model for polished detail, stability, and final renders.",
        outputDescription: "Native 1080p generation · maximum fidelity",
        supports1080p: true,
    },
};
export const openAIVideoModelSchema = z.enum(OPENAI_VIDEO_MODELS);
export const updateVideoModelSchema = z.object({
    model: openAIVideoModelSchema,
});
export function getOpenAIVideoModelProfile(model) {
    return OPENAI_VIDEO_MODEL_PROFILES[model];
}
export function isOpenAIVideoModel(value) {
    return openAIVideoModelSchema.safeParse(value).success;
}
//# sourceMappingURL=video-models.js.map